import React from "react";
import { NavLink } from "react-router-dom";

const menu = [
  { label: "Dashboard", path: "/accounting" },
  { label: "Registration Verify", path: "/accounting/registration" },

  // Main combined page
  { label: "Tender EMD", path: "/accounting/tender-payments" },

  // Separate tender fee page
  { label: "Tender Fee", path: "/accounting/tender-fee" },

  { label: "RA Bill Verify", path: "/accounting/ra-bills" },
  { label: "Contractor Ledger", path: "/accounting/ledger" },
  { label: "Reports", path: "/accounting/reports" },
  { label: "RA Payments", path: "/accounting/ra-payments" },
];

export default function AccountingSidebar({ role = "ACCOUNTANT" }) {
  const finalMenu = menu.filter((m) => !m.ceoOnly || role === "CEO");

  return (
    <aside className="w-72 min-h-screen bg-slate-950 text-white">
      <div className="p-6 border-b border-slate-800">
        <h1 className="text-xl font-black">Shine Agri</h1>
        <p className="text-xs text-slate-400">Accounting Automation</p>

        <span className="mt-3 inline-block bg-emerald-600 px-3 py-1 rounded-full text-xs font-bold">
          {role}
        </span>
      </div>

      <nav className="p-4 space-y-2">
        {finalMenu.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === "/accounting"}
            className={({ isActive }) =>
              `block px-4 py-3 rounded-xl text-sm font-semibold ${
                isActive
                  ? "bg-emerald-600 text-white"
                  : "text-slate-300 hover:bg-slate-800"
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}